
export const APPROVED_CLAIMS = {
  HERO_HEADLINE: "Standardized 10.56% annual cost (representative example)",
  AFFORDABILITY: "Among the most affordable MSME working-capital options in our segment (representative example)",
  SPEED: "Decision in ~30 minutes (subject to complete documents and network availability)",
  CRB_DATA: "We do not use CRB listings as the primary basis for approval. We assess current business cash flows and behavior.",
  GROWTH_BENEFIT: "20-40% potential revenue increase within the first 6 months",
  SAVINGS_DEMO: "Save up to 94% on interest compared to traditional digital lenders",
  TIER_SYSTEM: "5 growth tiers with 18 capital tranches",
  ON_TIME_RULE: "90% on-time progression rule to unlock the next credit tier",
  STANDARD_RATES: "Standard growth tiers ranging from 10.56% to 10.74% EIR per annum",
  // Primary email shown to customers in the UI
  SUPPORT_EMAIL: "support@chuibusiness.com",
  // Messaging for successful intake
  INTAKE_SUCCESS_MSG: "Your intake has been funneled to our Sales Directorate.",
  // Internal team distribution list for backend notifications
  NOTIFICATION_LIST: [
    "shalton.ogola@gmail.com",
    "support@chuibusiness.com",
    "nelly.kathomi14@gmail.com",
    "nelly.kathomi@chuibusiness.com"
  ]
};